import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from '../User.scss';
import detailStyles from './Details.scss';
import DateTime from 'common/components/DateTime/DateTime';

export class UserDetails extends Component {

    render() {
        const { user } = this.props;

        return (
            <div className={styles.container} data-cy="UserDetails">
                <section>
                    <ul className={detailStyles.userDetails}>
                        <li className={detailStyles.detail}>
                            Display Name: { user.displayName }
                        </li>
                        <li className={detailStyles.detail}>
                            First Name: { user.firstName }
                        </li>
                        <li className={detailStyles.detail}>
                            Last Name: { user.lastName }
                        </li>
                        <li className={detailStyles.detail}>
                            Email Address: { user.emailAddress }
                        </li>
                        <li className={detailStyles.detail}>
                            Created At: <DateTime value={user.createdAt} applyTimezoneOffset={true}/>
                        </li>
                        <li className={detailStyles.detail}>
                            Status: { user.isActive ? 'Active' : 'Inactive' }
                        </li>
                    </ul>
                </section>
            </div>
        );
    }

}

UserDetails.propTypes = {
    user: PropTypes.object.isRequired
};

export default UserDetails;
